import {
    ExamplePagesOccupationsByKey,
    ExamplePagesGPTData,
    getExamplePagesSEODomainByKey,
    ExamplePagesBeats,
    ExamplePagesOccupations,
    ExamplePagesOccupationBeats
} from "authory-api-types/dist/seo";
import { EmbedConf, ExamplesPageLayout } from "../../pagelayouts/examples";
import { APPLICATION_ROUTES } from "../../types/routes";
import { getUserExamples } from "../../api/examples";
import { ExampleUserListQueryParams, ExampleUserListResponse } from "authory-api-types/dist/types";
import { SEO_URL_EXAMPLE_PAGES_SUFIX } from "authory-api-types/dist/seo/seo_url";
import { EmbedMode } from "../../utils/embeds";

const occupations = ExamplePagesOccupationsByKey();

const getPanelLinks = (domain?: string) => {
    switch (domain) {
        case "beats":
            return ExamplePagesBeats;
        case "occupation":
            return ExamplePagesOccupations;
        case "occupationbeats":
            return ExamplePagesOccupationBeats;
        default:
            return [];
    }
};

export interface ExampleJobPageProps {
    userListReponse: ExampleUserListResponse;
    jobData: ExamplePagesGPTData;
    embedConf: EmbedConf[];
    domain?: string;
}

const ExampleJobPage = ({ userListReponse, jobData, embedConf, domain }: ExampleJobPageProps) => {
    const panelLinks = getPanelLinks(domain);

    return (
        <ExamplesPageLayout
            title={<>{jobData?.headline}</>}
            description={
                <>
                    {jobData.intro &&
                        jobData.intro.split("\n").map((pr) => (
                            <>
                                {pr}
                                <br />
                            </>
                        ))}
                </>
            }
            panelLinks={[]}
            categoriesLinks={Object.keys(occupations)
                .map((key: string) => occupations[key])
                //@ts-ignore
                .filter((occ) => !!panelLinks.find((link) => link.key === occ.key))
                .map((occ) => ({ url: `${APPLICATION_ROUTES.EXAMPLES}/${occ.key}${SEO_URL_EXAMPLE_PAGES_SUFIX}`, label: occ.occupation }))}
            masonryItems={userListReponse}
            ogTitle={jobData?.title}
            ogDescription={jobData?.intro}
            urlKey={jobData.key}
            faq={jobData.faq}
            embedConf={embedConf}
            skipCarousel={domain === "occupationbeats"}
        />
    );
};

export async function getStaticPaths() {
    let paths: any[] = [];

    if (process.env.EXAMPLES_PAGES_PIPELINE) {
        paths = Object.keys(occupations)
            .map((key: string) => occupations[key])
            .map((occ) => ({
                params: { job: `${occ.key}${SEO_URL_EXAMPLE_PAGES_SUFIX}` }
            }));

        // temporary - also push old pages for SEO reasons
        for (const key of Object.keys(occupations)) {
            const internalOcc = occupations[key];

            paths.push({
                params: { job: `${internalOcc.key}` }
            });
        }
    }

    return { paths, fallback: process.env.NODE_ENV === "development" ? "blocking" : false };
}

export async function getStaticProps(ctx: any) {
    const job = (ctx.params.job as string).replace(SEO_URL_EXAMPLE_PAGES_SUFIX, "");

    const params = new ExampleUserListQueryParams();
    params.key = job;

    const jobData = occupations[job];

    // Get the author
    let userListReponse: ExampleUserListResponse;

    try {
        userListReponse = await getUserExamples(params);
    } catch (e) {
        console.log(e);
    }

    const domain = getExamplePagesSEODomainByKey(job);

    return {
        props: {
            domain,
            userListReponse: userListReponse!,
            jobData,
            embedConf: userListReponse!.users.map((user) => ({
                embedMode: Math.random() > 0.15 ? EmbedMode.normal : EmbedMode.compact,
                showSocialMedia: Math.random() > 0.15,
                showHighlight: Math.random() > 0.15,
                items: Math.floor(Math.random() * Math.min(user.articles.articles.length, 5))
            }))
        }
    };
}

export default ExampleJobPage;
